import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULTS = {
  spots_remaining: 7,
  spots_message: "Only {n} Spots Remaining This Month",
  promo_end_date: null,
  video_url: "",
  video_title: "A MESSAGE FROM CHRIS CORMIER",
  video_thumbnail: "",
  price_monthly: "$500",
  price_six_month: "$1,500",
  price_twelve_month: "$2,900",
  whatsapp_number: "16193876711",
};

let cachedSettings = null;
let cachePromise = null;

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(cachedSettings || DEFAULTS);
  const [loading, setLoading] = useState(!cachedSettings);

  useEffect(() => {
    if (cachedSettings) return;
    if (!cachePromise) {
      cachePromise = axios
        .get(`${API}/settings`)
        .then((res) => {
          cachedSettings = { ...DEFAULTS, ...res.data };
          return cachedSettings;
        })
        .catch(() => {
          cachedSettings = DEFAULTS;
          return DEFAULTS;
        });
    }
    cachePromise.then((data) => {
      setSettings(data);
      setLoading(false);
    });
  }, []);

  return { settings, loading };
};
